import SignUpForm from "./SignUp/SignUpForm";

const SignUpPage = () => {
  return (
    <div
      className="flex justify-center h-full w-full bg-gradient-to-r from-blue2 via-blue1 to-blue3"
    >
      <SignUpForm />
    </div>
  );
};

export default SignUpPage;
